import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxLoadPanelModule,
    DxScrollViewModule,
    DxDataGridModule,
} from 'devextreme-angular';
import { PurchaseOrderItemDto, PurchaseOrderStatus } from '@services';
import { GridPageComponent } from '../../../../../common/grid-page.component';
import EnumUtils from '../../../../../../shared/enum-utils';
import { CustomStore } from 'devextreme-aspnet-data-nojquery';

@Component({
    selector: 'app-purchase-order-items',
    standalone: true,
    imports: [
        CommonModule,
        DxLoadPanelModule,
        DxScrollViewModule,
        DxDataGridModule,
    ],
    templateUrl: './purchase-order-items.component.html',
})
export class PurchaseOrderItemsComponent extends GridPageComponent<PurchaseOrderItemDto> {
    @Input() purchaseOrderItems: CustomStore | PurchaseOrderItemDto[] = [];
    @Input() showPurchasingOrder: boolean = false;

    constructor() {
        super();
        this.init(PurchaseOrderItemDto);
    }

    customizeSum(data: any) {
        return `Total: ${data.value}`;
    }

    protected getStatusBadgeClass(status: PurchaseOrderStatus): string {
        return EnumUtils.getPurchaseStatusBadgeClass(status);
    }
}